import { Component } from "react";

export default class ErrorBoundaryBac extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("❌ Error atrapado por ErrorBoundaryBac:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          position: "fixed", inset: 0, background: "#eef1e7", zIndex: 4000,
          display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
        }}>
          <div style={{ background: "#fff", borderRadius: 16, padding: "36px 32px", maxWidth: 380, textAlign: "center", boxShadow: "0 10px 40px rgba(0,0,0,.12)" }}>
            <div style={{ fontSize: 40, marginBottom: 10 }}>⚠️</div>
            <h5 style={{ fontWeight: 800, color: "#b3261e", marginBottom: 8 }}>Algo salió mal</h5>
            <p style={{ fontSize: 13, color: "#6c757d", marginBottom: 20 }}>
              La aplicación tuvo un problema inesperado. Tus datos guardados NO se pierden — al darle "Reintentar" y volver a abrir el formulario que estabas llenando, te va a preguntar si quieres continuarlo donde ibas (excepto las fotos, esas sí toca volver a tomarlas).
            </p>
            <button onClick={() => this.setState({ error: null })} style={{
              background: "#16342a", color: "#fff", border: "none", borderRadius: 10,
              padding: "10px 24px", fontWeight: 700, fontSize: 13.5, cursor: "pointer",
            }}>
              🔄 Reintentar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}